var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title-bar-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"title-bar-menu"},[_c('logout-header',{attrs:{"active-selected":"logout"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }